// The profile link of the mention a post's text starts with, or null when
// the text starts with anything else (words, a link, a picture).
export const leadingMentionUrl = (html) => {
  if (!html) return null
  const body = new DOMParser().parseFromString(html, 'text/html').body
  const walker = document.createTreeWalker(
    body,
    NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
  )
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.trim()) return null
      continue
    }
    if (node.tagName === 'IMG') return null
    if (node.tagName === 'A') {
      return node.classList.contains('mention')
        ? node.getAttribute('href')
        : null
    }
  }
  return null
}
